import React from "react";
import { Grid, Card, Box } from "@mui/material";

export function CircularProgress() {
    const ref = React.useRef(null); // Create a ref for the progress arc

    // Function to update the progress arc
    function updateProgress(progressArc, progress) {
        progress = Math.min(Math.max(progress, 0), 1); // Clamp progress between 0 and 1
        const startX = 20;
        const startY = 80;
        const radius = 60;
        const endAngle = Math.PI * progress; // Progress mapped to half-circle (0 to π)
        const endX = startX + radius * (1 - Math.cos(endAngle)); // Calculate end X
        const endY = startY - radius * Math.sin(endAngle); // Calculate end Y

        // Always set largeArcFlag to 0 for a half-circle progress bar
        const largeArcFlag = 0;

        // Update the 'd' attribute of the progress arc
        progressArc.setAttribute('d', `M${startX} ${startY} A${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}`);
    }

    // Function to animate the progress arc
    function animateProgress(progressArc, targetProgress, duration = 1000) {
        const startTime = performance.now();
        const initialProgress = parseFloat(progressArc.getAttribute('data-progress')) || 0;

        function animate(currentTime) {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            const currentProgress = initialProgress + (targetProgress - initialProgress) * progress;
            updateProgress(progressArc, currentProgress); // Pass progressArc here
            progressArc.setAttribute('data-progress', currentProgress);
            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        }

        requestAnimationFrame(animate);
    }

    // Animate the progress arc when the component mounts
    React.useEffect(() => {
        if (ref.current) {
            animateProgress(ref.current, 1, 2000); // Animate to 100% progress over 2 seconds
        }
    }, []);

    return (
        <svg width="160" height="100" xmlns="http://www.w3.org/2000/svg">
            {/* Background arc */}
            <path
                id="backgroundArc"
                d="M20 80 A60 60 0 0 1 140 80"
                fill="none"
                stroke="#e0e0e0"
                strokeWidth="20"
                strokeLinecap="round"
            />
            {/* Progress arc */}
            <path
                ref={ref} // Attach the ref to this path
                d="M20 80 A60 60 0 0 1 20 80"
                fill="none"
                stroke="#227d52"
                strokeWidth="20"
                strokeLinecap="round"
                data-progress="0" // Initialize progress
            />
        </svg>
    );
}